import React, { useEffect, useRef, useState } from 'react';
import { Logger } from '@saviynt/common';
import { ButtonIcon, Icon } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utils/localization';

import invertedMessages from './messages';
import Overlay from './Overlay';

function CertsDiscoveryCenter() {
  const [isPendoInitialized, setIsPendoInitialized] = useState(false);
  const [isDiscoveryCenterOpen, setIsDiscoveryCenterOpen] = useState(false);
  const discoveryCenterRef = useRef(null);

  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const l = useInvertedLocalize(invertedMessages);

  const resourceCenter =
    window.pendo?.BuildingBlocks?.BuildingBlockResourceCenter;

  const launchResourceCenter = () => {
    if (resourceCenter) {
      resourceCenter.getResourceCenter().show();
      setIsDiscoveryCenterOpen(true);
      setIsOverlayOpen(true);
    } else {
      Logger.error('Discovery Center is not available');
    }
  };

  const dismissResourceCenter = () => {
    if (resourceCenter) {
      resourceCenter.dismissResourceCenter();
      setIsDiscoveryCenterOpen(false);
      setIsOverlayOpen(false);
    } else {
      Logger.error('Discovery Center is not available');
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.pendo) {
        setIsPendoInitialized(true);
        clearInterval(intervalId);
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  const handleOutsideClick = (event) => {
    if (
      isDiscoveryCenterOpen &&
      (event.target.closest('._pendo-resource-center-close-button') ||
        !event.target.closest('#pendo-resource-center-container'))
    ) {
      dismissResourceCenter();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isDiscoveryCenterOpen]);

  if (!isPendoInitialized) return null;

  const handleClose = () => {
    setIsOverlayOpen(false);
  };

  return resourceCenter ? (
    <>
      <Overlay isOpen={isOverlayOpen} onClose={handleClose} />
      <div ref={discoveryCenterRef}>
        <ButtonIcon
          size='large'
          kind='ghost'
          onClick={() => launchResourceCenter()}
          icon={<Icon size='large' kind='HelpOutlined' />}
          ariaLabel={l('Open Discovery Center')}
        />
      </div>
    </>
  ) : null;
}

export default CertsDiscoveryCenter;
